module.exports = __webpack_public_path__ + "static/media/game-preview.de5d959b.png";